import { makeRequest } from "./client";

export type DashboardAnnouncementClient = {
  announcementId: string;
  title: string;
  imageUrl?: string;
  presentation: "toast" | "modal";
  priority: number;
  cta?: { label: string; href: string };
  startsAt?: string;
  endsAt?: string;
  sendGeneration?: number;
};

export type DashboardAnnouncementAckAction = "seen" | "click" | "dismiss";

export const dashboardAnnouncementsApi = {
  list: async (
    orgId: string,
    token: string
  ): Promise<{ announcements: DashboardAnnouncementClient[]; count: number }> => {
    return makeRequest(`/v1/org/${orgId}/dashboard-announcements`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  ack: async (
    orgId: string,
    announcementId: string,
    token: string,
    action: DashboardAnnouncementAckAction = "dismiss"
  ): Promise<{ message: string; announcementId: string; action: string }> => {
    return makeRequest(
      `/v1/org/${orgId}/dashboard-announcements/${announcementId}/ack`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: JSON.stringify({ action }),
      }
    );
  },
};
